import(/* webpackMode: "eager", webpackExports: ["BlogListClient"] */ "/vercel/path0/components/blog/blog-list-client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/export-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/faq-item.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/lead-capture.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/lista-itens.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/mobile-result-bar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/money-field.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/premium-showcase.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/recent-calcs-strip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/salvar-calculo-cta.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/soft-export.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/stepper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/use-animated-number.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calc/use-calc-telemetry.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
